import React from 'react'
import ReactDOM from 'react-dom/client'
import { startDeployVersionGuard } from '@huay/shared/deployVersionGuard'
import App from './App'

startDeployVersionGuard({ appName: 'user-ht-gold' })

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
